import React from 'react'
import Highlighter from 'react-highlight-words'
import styled from '@emotion/styled'

import {cssTheme} from '@vio/atlas/themes'
import {hexToRGBAString} from '@vio/core/src/utils/css'

import {TranslationState} from './ReviewCommentWrapper'

const HighlighterWrapper = styled.div`
  .--review-text-highlight {
    background-color: ${hexToRGBAString(
      cssTheme.colors.content.warning.secondary,
      0.5
    )};
  }
`

interface Props {
  translationState: TranslationState
  translatedText: string
  originalText: string
  searchKeywords?: string[]
}
const ReviewTextComponent: React.FC<Props> = ({
  translationState,
  translatedText,
  originalText,
  searchKeywords
}) => {
  if (translationState === 'translated' && translatedText) {
    return <div dir="auto" dangerouslySetInnerHTML={{__html: translatedText}} />
  }

  if (searchKeywords && searchKeywords?.length > 0 && originalText) {
    return (
      <HighlighterWrapper dir="auto">
        <Highlighter
          highlightClassName="--review-text-highlight"
          autoEscape
          textToHighlight={originalText}
          searchWords={searchKeywords}
        />
      </HighlighterWrapper>
    )
  }
  return <div dir="auto">{originalText}</div>
}

export const ReviewText = React.memo(ReviewTextComponent)
